<section class="hero wave-bg">
  <div class="container hero-content hero-content--centered">
    <h1>
      Audit de Code & 
      <span class="accent"> Modernisation d'Applications Legacy</span>
    </h1>
    <p class="hero-description">
      Votre application métier ralentit votre croissance et accumule des bugs ? Nous transformons votre dette technique en levier de performance stratégique par un audit approfondi et une modernisation sécurisée.
    </p>
     <div class="cta-row">
       <a 
        href="https://cal.mesh-box.fr/ogirodin/30min"
        class="button primary large" 
        data-cal-link="ogirodin/30min" 
        data-cal-config='{"layout":"month_view"}'
      >
        Auditer mon code
      </a>
    </div>
    <div class="mt-6 flex justify-center">
      <app-cii-badge variant="inline" />
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <app-cii-badge variant="table" />
  </div>
</section>

<section class="section alt">
  <div class="container max-w-4xl">
    <h2>Sortir de l'impasse technique avec l'Audit de Code Senior</h2>
    <p class="mb-6">
      Le "Legacy Code" n'est pas une fatalité. C'est souvent le résultat d'années de développement sans vision architecturale globale ou d'un turnover important au sein des équipes techniques. Notre audit de code ne se contente pas de lister des erreurs de syntaxe ; il analyse la structure profonde de votre logiciel pour identifier les goulots d'étranglement et les risques de sécurité majeurs.
    </p>
    <h3>Une méthodologie d'audit éprouvée</h3>
    <p class="mb-6">
      Nous utilisons des outils d'analyse statique de pointe combinés à une revue manuelle par des experts seniors. Nous évaluons la testabilité du code, le respect des principes SOLID, la gestion de la sécurité des données et l'adhérence aux standards de l'industrie (OWASP pour la sécurité web). Le résultat est un rapport clair, priorisant les actions correctives selon leur impact sur votre business.
    </p>
  </div>
</section>

<section class="section">
  <div class="container">
    <h2>Stratégies de Migration : Passer de AngularJS à Angular moderne</h2>
    <p class="mb-8">
      Migrer une application de grande envergure est une opération délicate qui nécessite une expertise spécifique pour éviter toute interruption de service ou perte de données.
    </p>
    <div class="grid-2">
      <div class="card">
          <h3>Migration Progressive (Hybrid Mode)</h3>
          <p>Utilisation de ngUpgrade pour faire cohabiter AngularJS et Angular. Cela permet de migrer les composants un par un tout en continuant à délivrer de nouvelles fonctionnalités métier.</p>
      </div>
      <div class="card">
          <h3>Réarchitecture en Clean Architecture</h3>
          <p>Nous profitons de la refonte pour isoler votre logique métier des contraintes du framework. Votre application devient ainsi plus robuste, plus facile à tester et surtout, plus durable face aux évolutions futures.</p>
      </div>
    </div>
    <div class="mt-10 text-center">
      <p>Besoin de conseils sur la migration ? Consultez la <a href="https://angular.dev/guide/upgrade" target="_blank" rel="noopener noreferrer" class="underline">documentation officielle d'Angular</a>.</p>
    </div>
  </div>
</section>

 <section class="section alt">
  <div class="container max-w-4xl">
    <h2>Refactoring et Réduction de la Dette Technique</h2>
    <p class="mb-6">
      Le refactoring n'est pas une réécriture complète, c'est une amélioration continue de la structure interne du code sans en changer le comportement externe. Nous intervenons sur vos briques critiques pour simplifier la logique, améliorer les performances et faciliter l'onboarding de nouveaux développeurs.
    </p>
    <div class="grid-3 mb-8">
      <div class="card text-center">
        <div class="text-3xl mb-2">⚡</div>
        <h4>Performance</h4>
        <p>Optimisation des bundles et du temps de rendu.</p>
      </div>
      <div class="card text-center">
        <div class="text-3xl mb-2">🛡️</div>
        <h4>Sécurité</h4>
        <p>Correction des failles et mise à jour des libs.</p>
      </div>
      <div class="card text-center">
        <div class="text-3xl mb-2">📈</div>
        <h4>Évolutivité</h4>
        <p>Structure prête pour les futures features.</p>
      </div>
    </div>

    <div style="margin-top: 2rem; padding: 1.5rem; background: var(--bg); border-radius: 8px; border-left: 4px solid var(--brand); box-shadow: var(--shadow);">
      <h3>Sécurisez votre MCO après modernisation</h3>
      <p>Une fois votre application remise à niveau, ne la laissez plus se dégrader. Notre offre de Tierce Maintenance Applicative (TMA) assure sa pérennité et son évolution constante.</p>
      <a routerLink="/maintenance-tma-nodejs-angular" style="color: var(--brand); font-weight: bold; text-decoration: none;">
        Découvrir notre offre de Maintenance →
      </a>
    </div>
  </div>
</section>

<!-- FAQ SECTION -->
<section class="section">
  <div class="container">
    <h2>Questions Fréquentes sur l'Audit et la Modernisation</h2>
    <div class="grid-2">
      <div class="card">
        <h4>Combien de temps dure un audit technique ?</h4>
        <p>Un audit complet dure généralement de 3 à 5 jours ouvrés. Il comprend une phase d'analyse, une phase de tests et la rédaction du rapport final actionnable.</p>
      </div>
      <div class="card">
        <h4>Peut-on moderniser sans tout arrêter ?</h4>
        <p>Oui, c'est notre spécialité. Grâce à des patterns comme le 'Strangler Fig Pattern', nous remplaçons progressivement les briques legacy par du code moderne sans impact pour vos utilisateurs.</p>
      </div>
    </div>
  </div>
</section>

<section class="section cta-final">
  <div class="container">
    <h2>Reprenez le contrôle de votre patrimoine logiciel</h2>
    <p>Ne laissez pas la technique devenir un frein à votre agilité. Planifions votre audit.</p>
    <a 
      href="https://cal.mesh-box.fr/ogirodin/30min"
      class="button primary large" 
      data-cal-link="ogirodin/30min" 
      data-cal-config='{"layout":"month_view"}'
    >
      Lancer le diagnostic gratuit
    </a>
  </div>
</section>